import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  getAllVendors,
  getAllCategory
} from '../../../store/actions/user/User';
import { getRestaurantCategory } from '../../../store/actions/admin/Admin';
import VendorCards from './VendorCards';
import BackDrop from '../Preloader/BackDrop';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box width="100%">{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    marginTop: '6px',
    width: '100%'
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`
  }
}));

function VerticalTabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    /*var latitude = localStorage.getItem("latitude");
    var longitude = localStorage.getItem("longitude");*/
    var latitude = '-123.02';
    var longitude = '343.43';
    var city = 'Australia';
    var superCategory = props.match.params.superCategory;
    props.getAllVendors(city, latitude, longitude, superCategory);
    props.getAllCategory(superCategory);
    props.getRestaurantCategory();
  }, []);

  const vendors = props.restaurant_vendors;
  const categories = props.categories;

  return (
    <>
      <BackDrop open={props.vendor_loader}></BackDrop>
      <div
        className="banner"
        style={{ marginTop: '3.4em', paddingLeft: '0', marginBottom: '2em' }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-1 col-md-3 col-sm-4 col-5"
              style={{ textAlign: 'left', marginLeft: '2.5%', padding: '0px' }}
            >
              <div>
                <img src="/img/s9.png" width="100%" alt="restaurant" />
              </div>
            </div>
            <div className=" col-sm-auto col-7" style={{ textAlign: 'left' }}>
              <h4
                style={{
                  color: 'whitesmoke',
                  fontWeight: 'bold',
                  fontSize: '30px'
                }}
              >
                Food Outlets
              </h4>
              {/* <h4 style={{color:'grey'}}>{localStorage.getItem('city')}</h4> */}
              <h5 style={{ color: 'grey' }}>{vendors.length} Store</h5>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12 col-sm-3"></div>
        </div>
      </div>
      <div className="container-fluid">
        <div
          className="row"
          style={{ textAlign: 'initial', color: 'rgb(23, 30, 48)' }}
        >
          <div className="col-sm-2 d-md-block d-none">
            <div className="row">
              <div className="col-12">
                <h2
                  style={{
                    textAlign: 'start',
                    color: '#112c50',
                    fontWeight: 'bold'
                  }}
                >
                  Sort By
                </h2>
              </div>
              <div className="col-12">
                <i
                  className="fa fa-window-minimize"
                  id="line"
                  aria-hidden="true"
                ></i>
                <i className="fa fa-window-minimize" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div className="col-sm-10 d-md-block d-none">
            <div className="row">
              <div className="col-12">
                <h2 style={{ textAlign: 'initial' }}>
                  <b>Restaurants and Cafe for you</b>
                </h2>
              </div>
              <div className="col-12">
                <i
                  className="fa fa-window-minimize"
                  id="line"
                  aria-hidden="true"
                ></i>
                <i className="fa fa-window-minimize" aria-hidden="true"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.root}>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={value}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          className={classes.tabs}
          style={{ width: '19.66%', marginLeft: '5px' }}
        >
          <Tab label="All " {...a11yProps(0)} />
          {categories.length !== 0
            ? categories.map((item, index) => (
                <Tab label={item.name} {...a11yProps(index + 1)} />
              ))
            : ''}
        </Tabs>
        <TabPanel value={value} index={0} style={{ width: '100%' }}>
          {/* <Typography variant='h5' align='center' style={{color:'rgb(23, 30, 48)'}}>Restaurants for you</Typography> */}
          <div className="container-fluid">
            <div className="row">
              {vendors.map((vendor) =>
                vendor.restaurantCategories.indexOf('all') >= 0 ? (
                  <div className="col-lg-4 col-md-6 col-sm-12">
                    <Link
                      to={
                        '/shop/' +
                        props.match.params.category +
                        '/' +
                        vendor.uid +
                        '/all/' +
                        vendor.distance
                      }
                      className="cardLink"
                    >
                      <VendorCards
                        key={vendor.uid}
                        vendor={vendor}
                        sub="Resteraunt"
                      ></VendorCards>
                    </Link>
                  </div>
                ) : (
                  'empty'
                )
              )}
            </div>
          </div>
        </TabPanel>
        {props.categories
          ? categories.map((subName, index) => (
              <TabPanel
                value={value}
                index={index + 1}
                style={{ width: '100%' }}
              >
                {/* <Typography variant='h5' align='center' style={{color:'rgb(23, 30, 48)'}}>{subName}</Typography> */}
                <div className="container-fluid">
                  <div className="row">
                    {vendors.map((vendor) =>
                      vendor.restaurantCategories.indexOf(subName) >= 0 ? (
                        <div className="col-lg-4 col-md-6 col-sm-12">
                          <Link
                            to={
                              '/shop/' +
                              props.match.params.category +
                              '/' +
                              vendor.uid +
                              '/all/' +
                              vendor.distance
                            }
                            className="cardLink"
                          >
                            <VendorCards
                              key={vendor.uid}
                              vendor={vendor}
                              sub={subName}
                            ></VendorCards>
                          </Link>
                        </div>
                      ) : (
                        ''
                      )
                    )}
                  </div>
                </div>
              </TabPanel>
            ))
          : ''}
      </div>
    </>
  );
}

const mapStateWithProps = (state) => ({
  restaurant_vendors: state.user.restaurant_vendors,
  categories: state.user.categories,
  loader: state.ui.user_loading,
  vendor_loader: state.ui.vendor_loader
});

const mapDispatchToProps = (dispatch) => ({
  getAllVendors: (city, latitude, longitude, superCategory) =>
    dispatch(getAllVendors(city, latitude, longitude, superCategory)),
  getAllCategory: (superCategory) => dispatch(getAllCategory(superCategory)),
  getRestaurantCategory: () => dispatch(getRestaurantCategory())
});

export default connect(mapStateWithProps, mapDispatchToProps)(VerticalTabs);
